import PasswordInput from './PasswordInput'

export default PasswordInput
